import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import PersonCard from '../components/common/PersonCard';

const segreteriaMembers = [
  { id: 'vicesegreteria', name: 'Giulia Marchetti', role: 'Vicesegretaria', territory: 'Milano', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop' },
  { id: 'organizzazione', name: 'Alessandro Ferretti', role: 'Resp. Organizzazione', territory: 'Torino', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop' },
  { id: 'comunicazione', name: 'Sofia Ricciardi', role: 'Resp. Comunicazione', territory: 'Bologna', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop' },
  { id: 'formazione', name: 'Davide Romano', role: 'Resp. Formazione', territory: 'Napoli', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&auto=format&fit=crop' },
  { id: 'enti-locali', name: 'Laura Bianchi', role: 'Resp. Enti Locali', territory: 'Firenze', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop' },
  { id: 'lavoro', name: 'Matteo Galli', role: 'Resp. Lavoro', territory: 'Roma', avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=200&auto=format&fit=crop' },
  { id: 'diritti', name: 'Anna Ferraro', role: 'Resp. Diritti', territory: 'Bari', avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?q=80&w=200&auto=format&fit=crop' },
  { id: 'ambiente', name: 'Simone Pace', role: 'Resp. Ambiente', territory: 'Palermo', avatar: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=200&auto=format&fit=crop' },
];

const SegreteriaPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Chi Siamo', path: '/chi-siamo' }, { label: 'Segreteria Nazionale' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Organizzazione" title="Segreteria Nazionale" subtitle="Il team operativo che guida i Giovani Democratici nel lavoro quotidiano." />
      <section className="section"><div className="container">
        {/* Segretario */}
        <div className="mb-12" style={{ textAlign: 'center' }}>
          <div style={{ width: 160, height: 160, borderRadius: 'var(--radius-full)', overflow: 'hidden', margin: '0 auto var(--space-4)' }}>
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&auto=format&fit=crop" alt="Marco Ferrara" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <h2 className="h2 mb-1">Marco Ferrara</h2>
          <div className="h4 text-primary mb-2">Segretario Nazionale</div>
          <p className="text-body-sm text-secondary" style={{ maxWidth: 500, margin: '0 auto' }}>28 anni, romano. Laureato in Scienze Politiche. Segretario Nazionale dal 2024.</p>
          <Link to="/persona-dettaglio" className="link mt-3" style={{ display: 'inline-block' }}>Profilo completo →</Link>
        </div>
        <div className="section-header mb-6"><h2 className="section-header__title">La Segreteria</h2></div>
        <div className="grid grid-4">
          {segreteriaMembers.map((p) => <PersonCard key={p.name} {...p} as="a" link={`/delega/${p.id}`} />)}
        </div>
      </div></section>
    </Layout>
  );
};

export default SegreteriaPage;
